import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './reward.scss';

import React, { useEffect, useState } from 'react';
import * as ua from '@umu/umu-ua';
import API from '@umu/umu-api';
import { fetch } from '@umu/umu-fetch';
import { components } from 'common';
const { If, Portal, Dialog, DialogHeader, DialogBody, DialogFooter, DialogFooterButton, Button, PreImg } = components;

import { IUserInfo } from '@umu/umu-types';

import UserAvatar from '../user/userAvatar/userAvatar';
import PageQrCodeDialog from '../@pageQrCodeDialog/pageQrCodeDialog';
import RewardInputDialog from '../@reward/components/@rewardInputDialog/rewardInputDialog';
import Pay from '../@pay/pay';
import { IOrderData } from '../../services/@payService/payService';
import { getCurrencySymbol } from '../../@utils/umuUtil';
import {
    WrapperUseMobileIframeLandscapeDisplayManager,
    IWrapperUseMobileIframeLandscapeDisplayProps,
} from '../../services/responsiveDisplay/course';
import Icon from './images/reward_crown.png';

interface IProps extends IWrapperUseMobileIframeLandscapeDisplayProps {
    payChannel: string[];
    orderData: IOrderData;
    relationId: number;
    onClose: () => void;
}

const LUCKY_QTY = [0.99, 1.68, 5.2, 5.21, 6.66, 8.88, 9.99];

const RandomInRange = (min: number, max: number) => {
    return Math.random() * (max - min) + min;
};

/**
 * 赞赏随机金额：
 * 20%几率在以下数字中随机：0.99，1.68，5.20，5.21，6.66，8.88，9.99
 * 64%几率在5.0-9.9元区域随机
 * 16%几率在0.99-4.99元区域随机
 */
const randomQuantity = () => {
    let ret = 0;

    const num = Math.random();
    if (num < 0.2) {
        // 概率 20%
        ret = LUCKY_QTY[Math.floor(Math.random() * LUCKY_QTY.length)];
    } else if (num < 0.84) {
        // 概率 64%
        ret = RandomInRange(5.0, 9.9);
    } else {
        // 概率 16%
        ret = RandomInRange(0.99, 4.99);
    }

    // 精确到分
    return ret.toFixed(2);
};

function Reward(props: IProps) {
    const canReward = (ua.isWeixinBrowser || !ua.isMobile) && props.payChannel[0];

    const [rewardQuantity, setRewardQuantity] = useState('');

    const [userInfo, setUserInfo] = useState<IUserInfo | null>(null);
    const getUserInfo = () => {
        fetch.get(API.Path.GET_USER_INFO.url, {}, { silent: true }).then((response: { data?: IUserInfo }) => {
            if (response.data) {
                setUserInfo(response.data);
            }
        });
    };

    const [rewardTotalCount, setRewardTotalCount] = useState(0);
    const getRewardTotalCount = () => {
        const relationId = props.relationId;
        fetch
            .get('/api/reward/getrewardcount', {
                group_id: relationId,
            })
            .then((res: any) => {
                setRewardTotalCount(res.data.count);
            });
    };

    // 组件初次加载时，异步拉取赞赏总数
    useEffect(() => {
        getRewardTotalCount();
    }, []);

    const goRewardList = () => {
        const relationId = props.relationId;
        if (props._isDisplayInIframeModeForCourse) {
            const url = [location.origin, '/session/rewardlist?group_id=' + relationId].join('');
            props._openSideIframe(url);
            // window.open('/session/rewardlist?group_id=' + relationId, '_blank')
        } else {
            window.location.href = '/session/rewardlist?group_id=' + relationId;
        }
    };

    const renderToWeixin = () => {
        return (
            <div className="reward-to-wx">
                <PageQrCodeDialog
                    show={true}
                    onClose={props.onClose}
                    title={lang('截屏保存二维码，用微信扫码赞赏')}
                    subTitle={lang('（微信-扫一扫-相册-图片）')}
                />
            </div>
        );
    };

    const [isShowPay, setIsShowPay] = useState(false);
    const renderPay = () => {
        if (!isShowPay) {
            return null;
        }

        // 转成分
        // 这里再 tofxied ，因为偶发会产生前面的数字没有被格式化两位小数的情况，未稳定复现
        const amount = Number((+rewardQuantity * 100).toFixed(0));
        if (isNaN(amount)) {
            throw new Error('支付金额错误！');
        }

        const orderData = Object.assign(props.orderData, {
            amount,
        });

        const payDesc = lang('赞赏金额');

        return (
            <Pay
                orderData={orderData}
                payDesc={payDesc}
                payChannel={props.payChannel}
                paySuccess={() => {
                    getUserInfo();
                    setIsShowSuccessDialog(true);
                    setIsShowRewardPanel(false);
                }}
                payFail={() => /* props.onClose() */ void 0}
                onClose={() => setIsShowPay(false)}
            />
        );
    };

    const [isShowCustomQuantity, setIsShowCustomQuantity] = useState(false);
    const onConfirmCustomQty = (val: string) => {
        setRewardQuantity(val);
        setIsShowPay(true);
    };
    const renderCustomQtyDialog = () => {
        if (!isShowCustomQuantity) {
            return null;
        }
        return (
            <RewardInputDialog
                min={1}
                max={9999}
                clsName="reward-input-dialog"
                onSave={onConfirmCustomQty}
                onClose={() => setIsShowCustomQuantity(false)}
            />
        );
    };
    const [isShowSuccessDialog, setIsShowSuccessDialog] = useState(false);
    const renderSuccessDialog = () => {
        if (!isShowSuccessDialog) {
            return null;
        }

        const currencySymbol = getCurrencySymbol();
        return (
            <Dialog
                hasMask={true}
                show={true}
                className="reward-success-dialog"
                canClose={true}
                close={() => props.onClose()}
            >
                <DialogHeader>
                    <PreImg>
                        <img className="reward-crown" src={Icon} alt="" />
                    </PreImg>
                </DialogHeader>
                <DialogBody>
                    <div className="reward-success-wrap">
                        <UserAvatar className="avat user-avatar" src={(userInfo && userInfo.avatar) || ''} width={55} />
                        <p className="reward-success-qty reward-money">
                            {currencySymbol}
                            {rewardQuantity}
                        </p>
                    </div>
                </DialogBody>
                <DialogFooter>
                    <DialogFooterButton className="umu-btn btn-text" onClick={goRewardList}>
                        {lang('查看全部赞赏')}
                    </DialogFooterButton>
                </DialogFooter>
            </Dialog>
        );
    };

    const [isShowRewardPanel, setIsShowRewardPanel] = useState(canReward);
    // ie下https://app.asana.com/0/1201739123936511/1202464071205688，通过触发重绘解决
    useEffect(() => {
        window.setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 2000)
    },  []);
    const renderRewardPanel = () => {
        if (!isShowRewardPanel) {
            return null;
        }

        let rewardTotalCountTip = rewardTotalCount + lang('次赞赏');
        if (rewardTotalCount === 1) {
            rewardTotalCountTip = rewardTotalCount + lang('次赞赏_1');
        }

        return (
            <Dialog show={true} hasMask={false}
                className={`reward-panel ${props._isDisplayInIframeModeForCourse ? 'iframe-mode': ''}`} canClose={false} width="100%">
                <DialogHeader>
                    <div className="dialog-title clearfix">
                        <Button alias="text" onClick={props.onClose}>
                            <i className="icon icon-entity entity-close size-s"></i>
                        </Button>
                        <Button alias="text" className="go-reward-list" onClick={goRewardList}>
                            {rewardTotalCountTip}
                            <i className="icon icon-arrow arrow1 right gray size-s" />
                        </Button>
                    </div>
                </DialogHeader>
                <DialogBody>
                    <div className="reward-quantity-wrap">
                        <p className="reward-quantity reward-money" onClick={() => setRewardQuantity(randomQuantity())}>
                            ￥{rewardQuantity || '0.99 - 9.99'}
                        </p>
                        <If condition={!rewardQuantity}>
                            <p className="reward-tip">{lang('点击随机金额')}</p>
                        </If>
                    </div>
                    <div className="do-reward">
                        <Button disabled={!rewardQuantity} onClick={() => setIsShowPay(true)}>
                            {lang('赞赏')}
                        </Button>
                    </div>
                    <If condition={!!rewardQuantity}>
                        <div className="do-custom-quantity">
                            <Button alias="text" onClick={() => setIsShowCustomQuantity(true)}>
                                {lang('点击输入自定义金额')}
                            </Button>
                        </div>
                    </If>
                </DialogBody>
            </Dialog>
        );
    };

    const render = () => {
        if (!canReward) {
            return renderToWeixin();
        }
        return (
            <div className="reward-content">
                {renderRewardPanel()}
                {renderPay()}
                {renderCustomQtyDialog()}
                {renderSuccessDialog()}
            </div>
        );
    };

    return <Portal preventBodyScroll={true}>{render()}</Portal>;
}

export default WrapperUseMobileIframeLandscapeDisplayManager(Reward);